import { fromJS } from 'immutable'
import {
  PROJECT_INFORMATION_APPROVE_REQUEST,
  PROJECT_INFORMATION_APPROVE_SUCCESS,
  PROJECT_INFORMATION_APPROVE_FAILURE,
  PROJECT_INFORMATION_APPROVE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case PROJECT_INFORMATION_APPROVE_REQUEST:
      return state
        .set('isFetching', true)
    case PROJECT_INFORMATION_APPROVE_SUCCESS: {
      const status = action.payload.updatedProjectSubmit.status === 'REJECTED'
      return state
        .set('project', fromJS(action.payload.updatedProjectSubmit))
        .set('isFetching', false)
        .set('status', 200)
        .set('message', `${status ? 'Rejected' : 'Approved'} Successfully.`)
    }
    case PROJECT_INFORMATION_APPROVE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('project', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
    case PROJECT_INFORMATION_APPROVE_RESET:
      return state
        .delete('project')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project-information/project-information-approve-reducer.js